"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

var _calicoUiKit = require("@calico/calico-ui-kit");

var _lodash = require("lodash");

var _ref = _react.default.createElement("div", null, _react.default.createElement(_calicoUiKit.Icon, {
  className: "white font-size-6",
  icon: "ios-cloud-download-outline"
}));

var DatasetDownloadButton = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(DatasetDownloadButton, _React$Component);

  function DatasetDownloadButton() {
    (0, _classCallCheck2.default)(this, DatasetDownloadButton);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(DatasetDownloadButton).apply(this, arguments));
  }

  (0, _createClass2.default)(DatasetDownloadButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          style = _this$props.style;
      var _this$props2 = this.props,
          format = _this$props2.format,
          onDownload = _this$props2.onDownload,
          size = _this$props2.size,
          src = _this$props2.src,
          title = _this$props2.title;
      return _react.default.createElement("div", {
        className: (0, _classnames.default)(className),
        style: style
      }, _react.default.createElement("div", {
        className: "relative",
        style: {
          width: '100%'
        }
      }, _react.default.createElement("div", {
        className: "relative",
        style: {
          paddingBottom: '100%'
        }
      }, _react.default.createElement("a", {
        className: "fill center-all bg-green white padding-2 shadow-l",
        style: {
          borderRadius: '0.25rem',
          wordBreak: 'break-word'
        },
        href: src || '#',
        role: "button",
        onClick: function onClick() {
          return (0, _lodash.isFunction)(onDownload) && onDownload(title);
        }
      }, _react.default.createElement("div", {
        className: "text-center"
      }, _ref, _react.default.createElement("div", {
        className: "bold",
        style: {
          lineHeight: '1.05'
        }
      }, title || 'Download'), _react.default.createElement("div", {
        className: "font-size-small smooth text-center padding-top-1"
      }, size && _react.default.createElement("span", {
        className: "inline-block",
        style: {
          marginLeft: '0.15em',
          marginRight: '0.15em'
        }
      }, size), format && _react.default.createElement("span", {
        className: "inline-block",
        style: {
          marginLeft: '0.15em',
          marginRight: '0.15em'
        }
      }, format)))))));
    }
  }]);
  return DatasetDownloadButton;
}(_react.default.Component);

DatasetDownloadButton.defaultProps = {
  format: null,
  onDownload: null,
  size: null,
  src: null,
  title: 'Download'
};
var _default = DatasetDownloadButton;
exports.default = _default;